/**
 * Panel-level Copilot Studio session hook.
 * Session data is loaded once in CopilotStudioProvider (App.tsx).
 */
import { useCopilotStudio, type UseCopilotStudioResult } from '@hooks/useCopilotStudio';

export interface UseCopilotChatPanelResult {
  copilot: UseCopilotStudioResult;
  isCopilotMode: boolean;
}

export const useCopilotChatPanel = (): UseCopilotChatPanelResult => {
  const copilot = useCopilotStudio();
  const isCopilotMode = copilot.loading || copilot.enabled;

  return { copilot, isCopilotMode };
};
